import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { useBannerSliderContext } from "@/components/BannerSlider/context/bannerSlider.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { TimerStatus } from "@/utils/hooks/timer/useTimer.types";
import { useClickTracking } from "@/utils/hooks/tracking/useClickTracking.hook";

import { useProgressBarContext } from "../context/progressBar.context";

const ProgressBarButton = () => {
    const { t } = useGranite();

    const { status, stopTimer, startTimer } = useProgressBarContext();

    const { trackingProps } = useBannerSliderContext();

    const isPaused = status === TimerStatus.Stopped;
    const isRunning =
        status === TimerStatus.Running || status === TimerStatus.Initial;

    const { onClick } = useClickTracking({
        "button-click": {
            name: `banner-slider-${isPaused ? "play" : "pause"}`,
            category: trackingProps["banner-slide-click"]?.category || "",
            placement: trackingProps["banner-slide-click"]?.placement
        }
    });

    return (
        <Button
            size="sm"
            color="primary"
            className={cn("tw:inline-block")}
            aria-label={t(
                `general.bannerSlider.progressBar.toggle.${isPaused ? "play" : "pause"}`
            )}
            outline={true}
            onClick={(e) => {
                onClick(e);
                switch (status) {
                    case TimerStatus.Running:
                        stopTimer();
                        break;
                    case TimerStatus.Stopped:
                        startTimer();
                        break;
                    default:
                        break;
                }
            }}
        >
            <i
                className={cn("las", {
                    "la-pause": isRunning,
                    "la-play": isPaused
                })}
            ></i>
        </Button>
    );
};

export { ProgressBarButton };
